import React from "react";
import { Helmet } from "react-helmet";

// Site-wide <link rel="canonical">, always with a trailing slash to match the
// URL that S3/CloudFront serves without a redirect and the sitemap lists.
// Gatsby v2 page paths have no trailing slash, so location.pathname is
// slashless at build time. A page can still override this with
// seo.canonical (rendered in Layout.js, deeper in the tree, so it wins) —
// the PPC landing pages point theirs at the main service page.
const siteUrl = "https://myops.co.il";

export const canonicalUrl = (pathname = "/") =>
  `${siteUrl}${pathname.endsWith("/") ? pathname : `${pathname}/`}`;

export const wrapPageElement = ({ element, props }) => {
  const href = canonicalUrl(props.location.pathname);
  return (
    <>
      <Helmet link={[{ rel: "canonical", key: href, href }]} />
      {element}
    </>
  );
};
